exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dateCell-080f7{font-size:.88rem}.clientsTable-c89d4 table>tbody>tr>td{padding:0}.clientsTable-c89d4 table>tbody>tr>td a{display:block;padding:16px;color:#000}.actionsButton-bf791{cursor:pointer}", ""]);

// Exports
exports.locals = {
	"dateCell": "dateCell-080f7",
	"clientsTable": "clientsTable-c89d4",
	"actionsButton": "actionsButton-bf791"
};